module.exports = __webpack_public_path__ + "img/BMW-logo.851b01cc.svg";